// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.akZyQR {
  border: none;
  padding: 0;
  margin: 0;
  outline: none;
  width: 100vw;
  height: 100vh;
  max-width: none;
  max-height: none;
  background: transparent;
}

.akZyQR::backdrop {
  display: none;
}

.EqZ3a3 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  width: 100%;
  height: 100%;
  cursor: pointer;
  outline: none;
}

.EqZ3a3:focus {
  /* Subtle focus indicator on the backdrop */
  box-shadow: inset 0 0 0 2px var(--focus-default, #1573d3);
}

.EqZ3a3:focus:not(:focus-visible) {
  /* Remove focus styles when not using keyboard navigation */
  box-shadow: none;
}

.PSqwWe {
  background: var(--surface-neutral-white, #ffffff);
  border-radius: var(--button-border-radius, 4px);
  box-shadow: var(--card-box-shadow, 0 2px 4px 0 rgba(0, 0, 0, 0.12));
  width: 90vw;
  height: 90vh;
  max-width: 800px;
  max-height: 600px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.r3OpfG {
  background: var(--surface-neutral-white, #ffffff);
  padding: var(--spacing-2, 16px) var(--spacing-3, 24px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.m379KR {
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
  font-size: var(--type-title-lg-font-size, 20px);
  font-weight: var(--type-title-lg-font-weight, 600);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
}

.slJdOQ {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-neutral-stronger, #666666);
  cursor: pointer;
  padding: var(--spacing-0-5, 4px);
  border-radius: var(--button-border-radius, 4px);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.slJdOQ:hover {
  background-color: var(--surface-neutral-pale, #fafafa);
  color: var(--text-neutral-dark, #1f1f1f);
}

.slJdOQ:focus {
  outline: 2px solid var(--focus-default, #1573d3);
  outline-offset: 2px;
}

.VGNb7n {
  flex: 1;
  overflow-y: auto;
  padding: var(--spacing-3, 24px);
  background: var(--surface-neutral-white, #ffffff);
  cursor: default;
}

.VGNb7n h1 {
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
  font-size: var(--type-heading-lg-font-size, 32px);
  font-weight: var(--type-heading-lg-font-weight, 600);
  color: var(--text-neutral-dark, #1f1f1f);
  margin-bottom: var(--title-global-margin-bottom, 20px);
  margin-top: 0;
}

.VGNb7n h2 {
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
  font-size: var(--type-heading-md-font-size, 24px);
  font-weight: var(--type-heading-md-font-weight, 600);
  color: var(--text-neutral-dark, #1f1f1f);
  margin-bottom: var(--spacing-2, 16px);
  margin-top: var(--spacing-3, 24px);
}

.VGNb7n h3 {
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
  font-size: var(--type-title-lg-font-size, 20px);
  font-weight: var(--type-title-lg-font-weight, 600);
  color: var(--text-neutral-dark, #1f1f1f);
  margin-bottom: var(--spacing-1-5, 12px);
  margin-top: var(--spacing-2-5, 20px);
}

.VGNb7n h4 {
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
  font-size: var(--type-title-md-font-size, 16px);
  font-weight: var(--type-title-md-font-weight, 600);
  color: var(--text-neutral-dark, #1f1f1f);
  margin-bottom: var(--spacing-1, 8px);
  margin-top: var(--spacing-2, 16px);
}

.VGNb7n p {
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
  font-size: var(--type-paragraph-md-font-size, 14px);
  font-weight: var(--type-paragraph-md-regular-font-weight, 400);
  line-height: var(--type-paragraph-md-regular-line-height, 180%);
  color: var(--text-neutral-dark, #1f1f1f);
  margin-bottom: var(--spacing-1-5, 12px);
  margin-top: 0;
}

.VGNb7n ul,
.VGNb7n ol {
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
  font-size: var(--type-paragraph-md-font-size, 14px);
  font-weight: var(--type-paragraph-md-regular-font-weight, 400);
  line-height: var(--type-paragraph-md-regular-line-height, 180%);
  color: var(--text-neutral-dark, #1f1f1f);
  margin-bottom: var(--spacing-1-5, 12px);
  padding-left: var(--spacing-2-5, 20px);
}

.VGNb7n li {
  margin-bottom: var(--spacing-0-5, 4px);
}

.VGNb7n strong,
.VGNb7n b {
  font-weight: var(--font-weight-semibold, 600);
  color: var(--text-neutral-dark, #1f1f1f);
}

.VGNb7n em,
.VGNb7n i {
  font-style: italic;
  color: var(--text-neutral-stronger, #666666);
}

.VGNb7n a {
  color: var(--link-default, #1573d3);
  text-decoration: underline;
  transition: color 0.2s ease;
}

.VGNb7n a:hover {
  color: var(--link-hover, #043362);
}

.VGNb7n a:visited {
  color: var(--link-visited, #750ac2);
}

.VGNb7n table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: var(--spacing-2, 16px);
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
  font-size: var(--type-paragraph-sm-font-size, 12px);
}

.VGNb7n th,
.VGNb7n td {
  border: 1px solid var(--stroke-neutral-subtle, #f2f2f2);
  padding: var(--spacing-1, 8px);
  text-align: left;
}

.VGNb7n th {
  background-color: var(--surface-neutral-pale, #fafafa);
  font-weight: var(--font-weight-semibold, 600);
  color: var(--text-neutral-dark, #1f1f1f);
}

.VGNb7n td {
  color: var(--text-neutral-stronger, #666666);
}

.VGNb7n blockquote {
  border-left: 4px solid var(--stroke-primary-medium, #d64000);
  background-color: var(--surface-primary-subtle, #ffeee5);
  padding: var(--spacing-1-5, 12px) var(--spacing-2, 16px);
  margin: var(--spacing-2, 16px) 0;
  font-style: italic;
  color: var(--text-neutral-stronger, #666666);
}

.VGNb7n hr {
  border: none;
  height: 1px;
  background-color: var(--stroke-neutral-subtle, #f2f2f2);
  margin: var(--spacing-3, 24px) 0;
}

/* Scrollbar customizada */
.VGNb7n::-webkit-scrollbar {
  width: 8px;
}

.VGNb7n::-webkit-scrollbar-track {
  background: var(--surface-neutral-pale, #fafafa);
  border-radius: 4px;
}

.VGNb7n::-webkit-scrollbar-thumb {
  background: var(--surface-neutral-soft, #e6e6e6);
  border-radius: 4px;
}

.VGNb7n::-webkit-scrollbar-thumb:hover {
  background: var(--surface-neutral-silver, #cccccc);
}

/* Responsividade */
@media (max-width: 768px) {
  .PSqwWe {
    width: 95vw;
    height: 95vh;
    margin: var(--spacing-1, 8px);
  }

  .r3OpfG {
    padding: var(--spacing-1-5, 12px) var(--spacing-2, 16px);
  }

  .VGNb7n {
    padding: var(--spacing-2, 16px);
  }

  .VGNb7n h1 {
    font-size: var(--type-heading-md-font-size, 24px);
  }

  .VGNb7n h2 {
    font-size: var(--type-title-lg-font-size, 20px);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/HTMLDocumentModal/HTMLDocumentModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,yDAAyD;AAC3D;;AAEA;EACE,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mEAAmE;EACnE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,wEAAwE;EACxE,+CAA+C;EAC/C,kDAAkD;EAClD,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,eAAe;EACf,gCAAgC;EAChC,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,wCAAwC;AAC1C;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,+BAA+B;EAC/B,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,wEAAwE;EACxE,iDAAiD;EACjD,oDAAoD;EACpD,wCAAwC;EACxC,sDAAsD;EACtD,aAAa;AACf;;AAEA;EACE,wEAAwE;EACxE,iDAAiD;EACjD,oDAAoD;EACpD,wCAAwC;EACxC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,wEAAwE;EACxE,+CAA+C;EAC/C,kDAAkD;EAClD,wCAAwC;EACxC,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;EACxE,+CAA+C;EAC/C,kDAAkD;EAClD,wCAAwC;EACxC,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,wEAAwE;EACxE,mDAAmD;EACnD,8DAA8D;EAC9D,+DAA+D;EAC/D,wCAAwC;EACxC,uCAAuC;EACvC,aAAa;AACf;;AAEA;;EAEE,wEAAwE;EACxE,mDAAmD;EACnD,8DAA8D;EAC9D,+DAA+D;EAC/D,wCAAwC;EACxC,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qCAAqC;EACrC,wEAAwE;EACxE,mDAAmD;AACrD;;AAEA;;EAEE,uDAAuD;EACvD,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4DAA4D;EAC5D,wDAAwD;EACxD,wDAAwD;EACxD,gCAAgC;EAChC,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uDAAuD;EACvD,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;AACpD;;AAEA,mBAAmB;AACnB;EACE;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,+CAA+C;EACjD;AACF","sourcesContent":[".htmlDocumentModal {\n  border: none;\n  padding: 0;\n  margin: 0;\n  outline: none;\n  width: 100vw;\n  height: 100vh;\n  max-width: none;\n  max-height: none;\n  background: transparent;\n}\n\n.htmlDocumentModal::backdrop {\n  display: none;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  outline: none;\n}\n\n.modal-overlay:focus {\n  /* Subtle focus indicator on the backdrop */\n  box-shadow: inset 0 0 0 2px var(--focus-default, #1573d3);\n}\n\n.modal-overlay:focus:not(:focus-visible) {\n  /* Remove focus styles when not using keyboard navigation */\n  box-shadow: none;\n}\n\n.modal-container {\n  background: var(--surface-neutral-white, #ffffff);\n  border-radius: var(--button-border-radius, 4px);\n  box-shadow: var(--card-box-shadow, 0 2px 4px 0 rgba(0, 0, 0, 0.12));\n  width: 90vw;\n  height: 90vh;\n  max-width: 800px;\n  max-height: 600px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.modal-header {\n  background: var(--surface-neutral-white, #ffffff);\n  padding: var(--spacing-2, 16px) var(--spacing-3, 24px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n.modal-title {\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n  font-size: var(--type-title-lg-font-size, 20px);\n  font-weight: var(--type-title-lg-font-weight, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--text-neutral-stronger, #666666);\n  cursor: pointer;\n  padding: var(--spacing-0-5, 4px);\n  border-radius: var(--button-border-radius, 4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.close-button:hover {\n  background-color: var(--surface-neutral-pale, #fafafa);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.close-button:focus {\n  outline: 2px solid var(--focus-default, #1573d3);\n  outline-offset: 2px;\n}\n\n.document-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--spacing-3, 24px);\n  background: var(--surface-neutral-white, #ffffff);\n  cursor: default;\n}\n\n.document-content :global(h1) {\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n  font-size: var(--type-heading-lg-font-size, 32px);\n  font-weight: var(--type-heading-lg-font-weight, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin-bottom: var(--title-global-margin-bottom, 20px);\n  margin-top: 0;\n}\n\n.document-content :global(h2) {\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n  font-size: var(--type-heading-md-font-size, 24px);\n  font-weight: var(--type-heading-md-font-weight, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin-bottom: var(--spacing-2, 16px);\n  margin-top: var(--spacing-3, 24px);\n}\n\n.document-content :global(h3) {\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n  font-size: var(--type-title-lg-font-size, 20px);\n  font-weight: var(--type-title-lg-font-weight, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin-bottom: var(--spacing-1-5, 12px);\n  margin-top: var(--spacing-2-5, 20px);\n}\n\n.document-content :global(h4) {\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n  font-size: var(--type-title-md-font-size, 16px);\n  font-weight: var(--type-title-md-font-weight, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin-bottom: var(--spacing-1, 8px);\n  margin-top: var(--spacing-2, 16px);\n}\n\n.document-content :global(p) {\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  font-weight: var(--type-paragraph-md-regular-font-weight, 400);\n  line-height: var(--type-paragraph-md-regular-line-height, 180%);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin-bottom: var(--spacing-1-5, 12px);\n  margin-top: 0;\n}\n\n.document-content :global(ul),\n.document-content :global(ol) {\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  font-weight: var(--type-paragraph-md-regular-font-weight, 400);\n  line-height: var(--type-paragraph-md-regular-line-height, 180%);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin-bottom: var(--spacing-1-5, 12px);\n  padding-left: var(--spacing-2-5, 20px);\n}\n\n.document-content :global(li) {\n  margin-bottom: var(--spacing-0-5, 4px);\n}\n\n.document-content :global(strong),\n.document-content :global(b) {\n  font-weight: var(--font-weight-semibold, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.document-content :global(em),\n.document-content :global(i) {\n  font-style: italic;\n  color: var(--text-neutral-stronger, #666666);\n}\n\n.document-content :global(a) {\n  color: var(--link-default, #1573d3);\n  text-decoration: underline;\n  transition: color 0.2s ease;\n}\n\n.document-content :global(a:hover) {\n  color: var(--link-hover, #043362);\n}\n\n.document-content :global(a:visited) {\n  color: var(--link-visited, #750ac2);\n}\n\n.document-content :global(table) {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: var(--spacing-2, 16px);\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n  font-size: var(--type-paragraph-sm-font-size, 12px);\n}\n\n.document-content :global(th),\n.document-content :global(td) {\n  border: 1px solid var(--stroke-neutral-subtle, #f2f2f2);\n  padding: var(--spacing-1, 8px);\n  text-align: left;\n}\n\n.document-content :global(th) {\n  background-color: var(--surface-neutral-pale, #fafafa);\n  font-weight: var(--font-weight-semibold, 600);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.document-content :global(td) {\n  color: var(--text-neutral-stronger, #666666);\n}\n\n.document-content :global(blockquote) {\n  border-left: 4px solid var(--stroke-primary-medium, #d64000);\n  background-color: var(--surface-primary-subtle, #ffeee5);\n  padding: var(--spacing-1-5, 12px) var(--spacing-2, 16px);\n  margin: var(--spacing-2, 16px) 0;\n  font-style: italic;\n  color: var(--text-neutral-stronger, #666666);\n}\n\n.document-content :global(hr) {\n  border: none;\n  height: 1px;\n  background-color: var(--stroke-neutral-subtle, #f2f2f2);\n  margin: var(--spacing-3, 24px) 0;\n}\n\n/* Scrollbar customizada */\n.document-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.document-content::-webkit-scrollbar-track {\n  background: var(--surface-neutral-pale, #fafafa);\n  border-radius: 4px;\n}\n\n.document-content::-webkit-scrollbar-thumb {\n  background: var(--surface-neutral-soft, #e6e6e6);\n  border-radius: 4px;\n}\n\n.document-content::-webkit-scrollbar-thumb:hover {\n  background: var(--surface-neutral-silver, #cccccc);\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .modal-container {\n    width: 95vw;\n    height: 95vh;\n    margin: var(--spacing-1, 8px);\n  }\n\n  .modal-header {\n    padding: var(--spacing-1-5, 12px) var(--spacing-2, 16px);\n  }\n\n  .document-content {\n    padding: var(--spacing-2, 16px);\n  }\n\n  .document-content :global(h1) {\n    font-size: var(--type-heading-md-font-size, 24px);\n  }\n\n  .document-content :global(h2) {\n    font-size: var(--type-title-lg-font-size, 20px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"htmlDocumentModal": `akZyQR`,
	"modal-overlay": `EqZ3a3`,
	"modalOverlay": `EqZ3a3`,
	"modal-container": `PSqwWe`,
	"modalContainer": `PSqwWe`,
	"modal-header": `r3OpfG`,
	"modalHeader": `r3OpfG`,
	"modal-title": `m379KR`,
	"modalTitle": `m379KR`,
	"close-button": `slJdOQ`,
	"closeButton": `slJdOQ`,
	"document-content": `VGNb7n`,
	"documentContent": `VGNb7n`
};
module.exports = ___CSS_LOADER_EXPORT___;
